var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line, _line2, _line3, _rect7, _path, _line4, _line5, _rect8, _path2, _line6, _line7, _rect9, _path3, _line8, _line9, _rect10, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 30,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    width: 7,
    height: 30,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 1,
    width: 16,
    height: 28,
    fill: "#33A000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 5,
    height: 23,
    fill: "#267800"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 5,
    width: 5,
    height: 23,
    fill: "#267800"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13,
    width: 12,
    height: 13,
    fill: "#267800"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12.5,
    x2: 19.9999,
    y2: 12.5,
    stroke: "#267800"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 11.5,
    x2: 19,
    y2: 11.5,
    stroke: "#267800"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10.5,
    x2: 18,
    y2: 10.5,
    stroke: "#267800"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 2,
    height: 10,
    fill: "#267800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8103 13.5692C14.871 13.3869 15.129 13.3869 15.1897 13.5692L15.9123 15.7368C15.9554 15.8663 15.859 16 15.7225 16H14.2775C14.141 16 14.0446 15.8663 14.0877 15.7368L14.5 14.5L14.8103 13.5692Z",
    fill: "#76D200"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 15.5,
    x2: 16,
    y2: 15.5,
    stroke: "#569900"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 19.5,
    x2: 16,
    y2: 19.5,
    stroke: "#569900"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 2,
    height: 3,
    fill: "#79A401"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8103 15.5692C17.871 15.3869 18.129 15.3869 18.1897 15.5692L18.9123 17.7368C18.9554 17.8663 18.859 18 18.7225 18H17.2775C17.141 18 17.0446 17.8663 17.0877 17.7368L17.5 16.5L17.8103 15.5692Z",
    fill: "#76D200"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 17.5,
    x2: 19,
    y2: 17.5,
    stroke: "#569900"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 21.5,
    x2: 19,
    y2: 21.5,
    stroke: "#569900"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 18,
    width: 2,
    height: 3,
    fill: "#79A401"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8103 15.5692C11.871 15.3869 12.129 15.3869 12.1897 15.5692L12.9123 17.7368C12.9554 17.8663 12.859 18 12.7225 18H11.2775C11.141 18 11.0446 17.8663 11.0877 17.7368L11.5 16.5L11.8103 15.5692Z",
    fill: "#76D200"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 17.5,
    x2: 13,
    y2: 17.5,
    stroke: "#569900"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 21.5,
    x2: 13,
    y2: 21.5,
    stroke: "#569900"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18,
    width: 2,
    height: 3,
    fill: "#79A401"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 3.5,
    x2: 7,
    y2: 3.5,
    stroke: "#267800"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 1.5,
    x2: 7,
    y2: 1.5,
    stroke: "#267800"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 2.5,
    x2: 7,
    y2: 2.5,
    stroke: "#267800"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 4.5,
    x2: 7,
    y2: 4.5,
    stroke: "#267800"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 3.5,
    x2: 26,
    y2: 3.5,
    stroke: "#267800"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 1.5,
    x2: 24,
    y2: 1.5,
    stroke: "#267800"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 2.5,
    x2: 25,
    y2: 2.5,
    stroke: "#267800"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 4.5,
    x2: 27,
    y2: 4.5,
    stroke: "#267800"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTank);
export default __webpack_public_path__ + "static/media/tank.7919d096fe67568a519b26f4edf9752f.svg";
export { ForwardRef as ReactComponent };